import {
  buildOrderLiteral,
  buildPagingLiteral,
  buildWhereLiteral,
  OrderBy,
} from '@/lib/graphql-query-builder';

// Reuses the "LeaveRequest" schema (same entity as hr-my-leave/hr-leave-manager),
// filtered to Title='Sick Leave' in the active organization. Newest request first by default, like
// the old sick leave list's `{ CreateDate: -1 }` sort.
export const DEFAULT_SICK_LEAVE_REQUESTS_ORDER: OrderBy[] = [
  { field: 'CreatedDate', direction: 'DESC' },
];

export const buildGetSickLeaveRequestsQuery = (
  where: Record<string, unknown>,
  pageNo: number,
  pageSize: number,
  order: OrderBy[] = DEFAULT_SICK_LEAVE_REQUESTS_ORDER
) => `
  query {
    LeaveRequests: getLeaveRequests(
      where: ${buildWhereLiteral(where)}
      order: ${buildOrderLiteral(order)}
      paging: ${buildPagingLiteral(pageNo, pageSize)}
    ) {
      hasNextPage
      hasPreviousPage
      totalCount
      totalPages
      pageSize
      pageNo
      items {
        ItemId
        CreatedDate
        Title
        UserId
        DisplayName
        DepartmentName
        StartDate
        EndDate
        Reason
        Status
        IsDocumentSendByDr
        Timezone
      }
    }
  }
`;
